import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { adjustmentApi, type CreateAdjustmentPayload } from "../lib/adjustmentApi";

export const ADJUSTMENT_KEYS = {
  all: ["adjustments"] as const,
  list: (businessId: string, targetPeriod: string) =>
    [...ADJUSTMENT_KEYS.all, businessId, targetPeriod] as const,
};

export function useAdjustments(
  businessId: string | null | undefined,
  targetPeriod: string | null | undefined,
) {
  return useQuery({
    queryKey: ADJUSTMENT_KEYS.list(businessId ?? "", targetPeriod ?? ""),
    queryFn: () => adjustmentApi.list(businessId!, targetPeriod!),
    enabled: !!businessId && !!targetPeriod,
    staleTime: 0,
    refetchOnMount: true,
  });
}

export function useCreateAdjustment(businessId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateAdjustmentPayload) =>
      adjustmentApi.create(businessId, payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ADJUSTMENT_KEYS.all });
    },
  });
}

export function useCancelAdjustment(businessId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ adjId, userId }: { adjId: string; userId: string }) =>
      adjustmentApi.cancel(businessId, adjId, userId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ADJUSTMENT_KEYS.all });
    },
  });
}
